import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: 'bi-speedometer2', hasChevron: false },
    { id: 'users', label: 'User Management', icon: 'bi-people', hasChevron: true },
    { id: 'subscriptions', label: 'Subscription Management', icon: 'bi-credit-card', hasChevron: true },
    { id: 'content', label: 'Content Management', icon: 'bi-file-text', hasChevron: true },
    { id: 'communication', label: 'Communication Management', icon: 'bi-chat-dots', hasChevron: true },
    { id: 'monitoring', label: 'System Monitoring', icon: 'bi-graph-up', hasChevron: true }
  ];

  const handleMenuClick = (itemId) => {
    if (itemId === 'dashboard') {
      // Dashboard is already active, no navigation needed
      return;
    }
    // For now, just show an alert. In a real app, you'd navigate to different pages
    alert(`${itemId} functionality coming soon!`);
  };

  const handleLogout = () => {
    // In a real app, you'd clear auth state and redirect to login
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      {/* Top Navigation Bar */}
      <header className="admin-header">
        <div className="admin-header-left">
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            aria-label="Toggle sidebar"
          >
            <i className="bi bi-list"></i>
          </button>
          <div className="admin-logo">
            <img 
              src="/epc-spark-symbol-only.png" 
              alt="EPC Spark" 
              className="logo-image"
            />
            <span className="logo-text">EPCSPARK-ADMIN</span>
          </div>
        </div>
        
        <div className="admin-header-right">
          <button className="header-icon-btn" aria-label="Notifications">
            <i className="bi bi-bell"></i>
            <span className="notification-badge">3</span>
          </button>
          <div className="user-profile">
            <button className="profile-btn" onClick={handleLogout}>
              <i className="bi bi-person-circle"></i>
              <span>Admin User</span>
              <i className="bi bi-chevron-down"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        <nav className="admin-nav">
          <ul className="nav-list">
            {menuItems.map((item) => (
              <li key={item.id} className="nav-item">
                <button 
                  className={`nav-link ${item.id === 'dashboard' ? 'active' : ''}`}
                  onClick={() => handleMenuClick(item.id)}
                >
                  <i className={`${item.icon} nav-icon`}></i>
                  <span className="nav-label">{item.label}</span>
                  {item.hasChevron && (
                    <i className="bi bi-chevron-right nav-chevron"></i>
                  )}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="admin-main">
        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
